<template>
    <Icon icon="circle-notch" spin :size="size" />
</template>

<script>
    import Icon from '../Icons/Icon'

    export default {
        name: 'Spinner',
        components: { Icon },
        props: {
            size: String
        }
    }
</script>